import { createTheme, globalTheme } from '@cld/component-theme';

export const popoverTheme = createTheme(
  {
    borderColor: globalTheme.palette.errorAlt,
    transition: {
      duration: '200ms',
    },
  },
  'popover'
);
